define(['backbone', 'models/OrderStatus'], function(
  Backbone,
  OrderStatusModel
) {
  return Backbone.Collection.extend({
    model: OrderStatusModel
  });
});
